'use client'
import {
  TAG_QUERY
} from "./chunk-TT4DXTR5.mjs";
import {
  EVENT_LIST_QUERY
} from "./chunk-6DESDILH.mjs";
import {
  CARD_QUERY
} from "./chunk-3CM7PDLU.mjs";
import {
  BUTTON_QUERY
} from "./chunk-OYEMYN5L.mjs";
import {
  CATEGORY_QUERY
} from "./chunk-ZZ3DUO5U.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/page.ts
var PAGE_SECTION_QUERY = ` 
id
title
titlePosition
subtitle
collapsableDescription{json}
renderType
titleColor
backgroundColor
innerBackgroundColor
topPadding
bottomPadding
container
sectionBackgroundsCollection(limit: 10) {
    items {${IMAGE_QUERY}}
}
logo {${IMAGE_QUERY}}
topDecorator {${IMAGE_QUERY}}
bottomDecorator {${IMAGE_QUERY}}
linksCollection(limit: 6){
    items{${BUTTON_QUERY}}
}
contentCollection(limit: 20) {
    items {
        __typename
        ... on Event {${EVENT_LIST_QUERY}}
        ... on Card {${CARD_QUERY}}
        ... on Category {${CATEGORY_QUERY}}
        ... on Tag {${TAG_QUERY}}
    }
}

`;

export {
  PAGE_SECTION_QUERY
};
//# sourceMappingURL=chunk-BQV6F2AE.mjs.map